export enum CncAdsPosition {
  LEADERBOARD_1 = 'leaderboard_1',
  RECTANGLE_480_1 = 'rectangle_480_1',
  MOBILE_RECTANGLE_2 = 'mobile_rectangle_2',
  RECTANGLE_REPEATER_325 = 'rectangle_repeater_325',
  HALFPAGE_1 = 'halfpage_1',
  // LOCAL STATIC
  LOCAL_LEADERBOARD_1 = 'local_leaderboard_1',
  LOCAL_LEADERBOARD_2 = 'local_leaderboard_2',
  LOCAL_HALFPAGE_1 = 'local_halfpage_1',
  LOCAL_HALFPAGE_2 = 'local_halfpage_2',
  UNDER_ARTICLE = 'under_article',
  // FROM ARTICLES API
  API_LEADERBOARD_1 = 'api_leaderboard_1',
  API_HALFPAGE_1 = 'api_halfpage_1',
}